export const DASHBOARD_URL = '/dashboard';
export const ADMIN_CLIENT_MANAGEMENT_URL = '/admin/clients';
export const ADMIN_CLIENT_ONBOARDING_URL = '/admin/client-onboarding';
export const ADMIN_CLIENT_PREVIEW_URL = '/admin/client-preview';
export const ADMIN_USER_LIST_URL = '/admin/members-list';
export const ADMIN_DATABASE_URL = '/admin/database';
export const ADMIN_HELP_CENTER_URL = '/admin/help-center';
export const ADMIN_HELP_PLANS_URL = '/admin/help/plans';

// Batch Jobs (admin) — background job runs, interface file processing and
// their job types, definitions, schedules and blackout dates.
export const ADMIN_BATCH_JOBS_URL = '/admin/batch-jobs';
export const ADMIN_BATCH_JOB_HISTORY_URL = `${ADMIN_BATCH_JOBS_URL}/job-history`;
export const ADMIN_BATCH_FILE_PROCESSING_URL = `${ADMIN_BATCH_JOBS_URL}/interface-file-processing`;
export const ADMIN_BATCH_SCHEDULES_URL = `${ADMIN_BATCH_JOBS_URL}/schedules`;
export const ADMIN_BATCH_JOB_DEFINITIONS_URL = `${ADMIN_BATCH_JOBS_URL}/job-definitions`;
export const ADMIN_BATCH_JOB_TYPES_URL = `${ADMIN_BATCH_JOBS_URL}/job-types`;
export const ADMIN_BATCH_BLACKOUT_DATES_URL = `${ADMIN_BATCH_JOBS_URL}/blackout-dates`;

// DB Migration (admin) — the cross-tenant migration audit trail, the migration
// catalogue and the .sql scripts behind it.
export const ADMIN_DB_MIGRATION_URL = '/admin/db-migration';
export const ADMIN_DB_MIGRATION_DASHBOARD_URL = `${ADMIN_DB_MIGRATION_URL}/dashboard`;
export const ADMIN_DB_MIGRATION_LIST_URL = `${ADMIN_DB_MIGRATION_URL}/migrations`;
export const ADMIN_DB_MIGRATION_SCRIPTS_URL = `${ADMIN_DB_MIGRATION_URL}/scripts`;

// Tenant Route URL
export const TENANT_USER_MANAGEMENT_URL = '/tenant/user-management';
export const TENANT_USER_PREVIEW_URL = '/tenant/user-preview';
export const TENANT_USER_ONBOARDING_URL = '/tenant/user-onboarding';
export const TENANT_USER_BULK_UPLOAD_PREVIEW_URL =
  '/tenant/user-bulk-upload-preview';
export const TENANT_MAINTENANCE_DASHBOARD = '/tenant/maintenance-dashboard';
export const TENANT_PARAMETER_COMPANY = '/tenant/parameters/company';
export const TENANT_PARAMETER_DEPT = '/tenant/parameters/department';
export const TENANT_PARAMETER_COST_CENTER = '/tenant/parameters/cost-center';
export const TENANT_PARAMETER_JOB_GRADE = '/tenant/parameters/job-grade';
export const TENANT_PARAMETER_TERMINATION =
  '/tenant/parameters/termination-reason';
export const TENANT_PARAMETER_KEY_MANAGEMENT_GRADE =
  '/tenant/parameters/key-management-grade';
export const TENANT_PARAMETER_COUNTRY = '/tenant/parameters/country';
export const TENANT_PARAMETER_DESIGNATION = '/tenant/parameters/designation';
export const TENANT_PARAMETER_DA_AGENT = '/tenant/parameters/depository-agent';
export const TENANT_PARAMETER_VESTING_SCHEDULE =
  '/tenant/parameters/vesting-schedules';
export const TENANT_PARAMETER_PLAN_OFFERING =
  '/tenant/parameters/plan-offering';
export const TENANT_PARAMETER_PERFORMANCE =
  '/tenant/parameters/performance-measures';
export const TENANT_USER_APPROVAL_URL = '/tenant/user-approval';
export const TENANT_USER_GROUP_PREVIEW = '/tenant/user-group-preview';

// Personal Ledger Routes
export const TENANT_MY_PERSONAL_LEDGER_URL = '/tenant/personal-ledger';
export const TENANT_MY_HOLDINGS_INFO_URL = '/tenant/my-holdings-info';
export const TENANT_SHARE_CREDITING_PROCESS_URL =
  '/tenant/share-crediting-process';
export const TENANT_SHARE_CREDITING_APPROVAL_URL =
  '/tenant/share-credit-approval';
export const TENANT_SHARE_CREDITING_PREVIEW_URL =
  '/tenant/share-credit-preview';
export const TENANT_BATCH_DETAILS_URL = '/tenant/batch-details';
export const TENANT_CREDITING_DETAILS_URL = '/tenant/crediting-details';
export const TENANT_ADMIN_DASHBOARD_URL = '/tenant/admin-dashboard';

/**
 * Dashboard > Personal Dashboard — the signed-in employee's own view of their
 * holdings (Overview / Analytics / Documents), and the tenant landing page.
 *
 * It sits on `DASHBOARD_URL`, which every post-login redirect already points
 * at; `TENANT_PERSONAL_DASHBOARD_URL` is kept only so old links and bookmarks
 * still resolve, and forwards there.
 */
export const TENANT_PERSONAL_DASHBOARD_URL = '/tenant/personal-dashboard';

/** Administration Hub — the maker-checker console, moved off `/dashboard`. */
export const TENANT_ADMINISTRATION_HUB_URL = '/tenant/administration-hub';

export const TENANT_TEMPLATE_MANAGEMENT_URL = '/tenant/template-management';
export const TENANT_TEMPLATE_CREATE_URL = '/tenant/create-template';
export const TENANT_TEMPLATE_PREVIEW_URL = '/tenant/template-preview';
export const TENANT_PROFILE_URL = '/tenant/my-profile';
export const TENANT_HELP_CENTER_URL = '/tenant/help-center';
export const TENANT_HELP_PLANS_URL = '/tenant/help/plans';
export const TENANT_AWARD_MANAGEMENT_URL = '/tenant/award-management';
export const TENANT_AWARD_MANAGEMENT_CREATE_URL =
  '/tenant/award-management/create';
export const TENANT_AWARD_MANAGEMENT_EDIT_URL = '/tenant/award-management/edit';
export const TENANT_AWARD_APPROVAL_URL = '/tenant/award-approval';
export const TENANT_AWARD_PREVIEW_URL = '/tenant/award-preview';
// Standalone route for the "View Awards / Grants" style award preview
// (AwardPreviewDetail), used by the Personal Ledger Award No hyperlink.
export const TENANT_AWARD_GRANT_PREVIEW_URL = '/tenant/award-grant-preview';
export const TENANT_VIEW_AWARDS_URL = '/tenant/view-awards';
export const TENANT_AWARD_ACTION_REQUIRED_URL = '/tenant/award-action-required';
export const TENANT_SYSTEM_FILES_URL = '/tenant/system-files';

// Coming Soon / Unimplemented Routes
export const TENANT_PLAN_MANAGEMENT_URL = '/tenant/plan-management';
export const TENANT_SECURITIES_MANAGEMENT_URL = '/tenant/securities-management';
export const TENANT_ENTER_ACHIEVEMENT_FACTOR_URL =
  '/tenant/award-admin/achievement-factor';
export const TENANT_ENTER_FAIR_VALUE_URL = '/tenant/award-admin/fair-value';
export const TENANT_GENERATE_AWARD_LETTER_URL =
  '/tenant/award-admin/generate-letter';
export const TENANT_GENERATE_FINAL_AWARD_LETTER_URL =
  '/tenant/award-admin/generate-final-letter';
export const TENANT_MANAGE_AWARD_URL = '/tenant/award-admin/manage';
export const TENANT_UPLOADED_AWARD_LIST_URL =
  '/tenant/award-admin/uploaded-list';
export const TENANT_MANAGE_AWARD_LIST_URL = '/tenant/award-admin/list';
export const TENANT_APPROVE_AWARD_URL = '/tenant/award-admin/approve';
export const TENANT_CANCEL_APPROVED_AWARD_URL = '/tenant/award-admin/cancel';
export const TENANT_SEND_AWARD_FOR_APPROVAL_URL =
  '/tenant/award-admin/send-for-approval';
export const TENANT_UPLOAD_AWARD_LIST_URL = '/tenant/award-admin/upload-list';
export const TENANT_APPROVAL_PREVIEW_URL = '/tenant/approval-preview';
export const TENANT_AWARD_LIST_PREVIEW_BY_ID = '/tenant/preview-award-list';

export const TENANT_FINAL_AWARD_URL = '/tenant/final-award-letter';
export const TENANT_FINAL_AWARD_ADJUST_REVIEW_URL =
  '/tenant/final-award-adjustment-review';
export const TENANT_FINAL_AWARD_PREVIEW = '/tenant/final-award/preview';

export const TENANT_CANCEL_AWARDS_URL = '/tenant/share-adjustment/cancel';
export const TENANT_DIVIDENDS_URL = '/tenant/share-adjustment/dividends';
export const TENANT_LAPSE_AWARDS_URL = '/tenant/share-adjustment/lapse';
export const TENANT_RETAIN_AWARDS_URL = '/tenant/share-adjustment/retain';
export const TENANT_SHARE_DILUTION_URL = '/tenant/share-adjustment/dilution';

export const TENANT_APPROVE_PAYMENT_LIST_URL =
  '/tenant/vesting-admin/cash/approve-payment';
export const TENANT_ENTER_MARKET_VALUE_URL =
  '/tenant/vesting-admin/cash/enter-market-value';
export const TENANT_ENTER_PAYMENT_DATE_URL =
  '/tenant/vesting-admin/cash/enter-payment-date';
export const TENANT_GENERATE_BATCH_CASH_URL =
  '/tenant/vesting-admin/cash/generate-batch';
export const TENANT_SUBMIT_BATCH_CASH_URL =
  '/tenant/vesting-admin/cash/submit-batch';

export const TENANT_MANAGE_TREASURY_SHARES_URL =
  '/tenant/vesting-admin/manage-treasury';

export const TENANT_AWARD_GOVERNANCE_URL =
  '/tenant/vesting-admin/award-governance';
export const TENANT_AWARD_GOVERNANCE_NEW_CASE_URL =
  '/tenant/vesting-admin/award-governance/new-case';
/** Maker edit of an in-progress governance case (`/:txnId` appended). */
export const TENANT_AWARD_GOVERNANCE_EDIT_CASE_URL =
  '/tenant/vesting-admin/award-governance/edit-case';
/** Case-list edit entry, keyed by the numeric case id (`/:id` appended). */
export const TENANT_AWARD_GOVERNANCE_EDIT_CASE_BY_ID_URL =
  '/tenant/vesting-admin/award-governance/edit-case/id';
/** Read-only case summary preview (`/:txnId` appended). */
export const TENANT_AWARD_GOVERNANCE_PREVIEW_URL =
  '/tenant/vesting-admin/award-governance/preview';
export const TENANT_AWARD_GOVERNANCE_ADD_ACTION_URL =
  '/tenant/vesting-admin/award-governance/add-action';
export const TENANT_AWARD_GOVERNANCE_SUMMARY_URL =
  '/tenant/vesting-admin/award-governance/summary';
/** Checker review of a governance case (`/:txnId` appended). */
export const TENANT_AWARD_GOVERNANCE_APPROVAL_URL =
  '/tenant/vesting-admin/award-governance/approval';

export const TENANT_ROUNDING_POLICY_URL = '/tenant/rounding-policy';
export const TENANT_POLICY_CREATE_URL = '/tenant/policies/new';
export const TENANT_POLICY_EDIT_URL = '/tenant/policies';
/** Read-only recap of a policy — the wizard's Summary step on its own. */
export const TENANT_POLICY_VIEW_URL = '/tenant/policies/view';
export const TENANT_POLICY_SIMULATE_URL = '/tenant/policies/simulate';
/** Checker review of a staged policy (`/:txnId` appended). */
export const TENANT_POLICY_APPROVAL_URL = '/tenant/policies/approval';
/** Maker edit of an in-progress / sent-back policy (`/:txnId` appended). */
export const TENANT_POLICY_REVISE_URL = '/tenant/policies/revise';

export const TENANT_ENTER_CREDITING_DATE_URL =
  '/tenant/vesting-admin/share/enter-date';
export const TENANT_GENERATE_BATCH_SHARE_URL =
  '/tenant/vesting-admin/share/generate-batch';
export const TENANT_SUBMIT_BATCH_SHARE_URL =
  '/tenant/vesting-admin/share/submit-batch';

export const TENANT_REPORTS_URL = '/tenant/reports';
/** "Build Custom Report" landing — the custom report definitions catalog. */
export const TENANT_REPORTS_CUSTOM_URL = '/tenant/reports/custom';
/** Standalone route for the "Build New Custom report" create form. */
export const TENANT_REPORTS_CREATE_URL = '/tenant/reports/create';
/** Edit route for a custom report definition; the definition id is the param. */
export const TENANT_REPORTS_EDIT_URL = '/tenant/reports/create/:id';
export const getReportEditUrl = (id: number | string) =>
  `${TENANT_REPORTS_CREATE_URL}/${id}`;
/** "Downloaded Reports" landing (coming soon for now). */
export const TENANT_REPORTS_DOWNLOADED_URL = '/tenant/reports/downloaded';
/** Preview route for a catalog report; the report's code is the route id. */
export const TENANT_REPORT_PREVIEW_URL = '/tenant/reports/preview';
export const getReportPreviewUrl = (reportCode: string) =>
  `${TENANT_REPORT_PREVIEW_URL}/${encodeURIComponent(reportCode)}`;
export const TENANT_REPORTS_USER_INFO_URL = '/tenant/reports/user-info';
export const TENANT_REPORTS_ALLOTMENT_URL = '/tenant/reports/allotment';
export const TENANT_REPORTS_AWARD_DETAIL_URL = '/tenant/reports/award-detail';
export const TENANT_REPORTS_EXPENSE_URL = '/tenant/reports/expense';
export const TENANT_REPORTS_GAINS_URL = '/tenant/reports/gains';
export const TENANT_REPORTS_KEY_MGMT_GAINS_URL =
  '/tenant/reports/key-mgmt-gains';
export const TENANT_REPORTS_KEY_MGMT_URL = '/tenant/reports/key-mgmt';
export const TENANT_REPORTS_LAPSE_URL = '/tenant/reports/lapse';
export const TENANT_REPORTS_SHARE_DILUTION_URL =
  '/tenant/reports/share-dilution';
export const TENANT_REPORTS_SUMMARY_URL = '/tenant/reports/summary';
export const TENANT_REPORTS_AUDIT_LOG_URL = '/tenant/reports/audit-log';
export const TENANT_REPORTS_USER_DETAIL_URL = '/tenant/reports/user-detail';
export const TENANT_REPORTS_VESTING_URL = '/tenant/reports/vesting';
